import { BaseElementToSimpleSapElementMapper } from './baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement } from '@/models/api/models/simpleSapElement';

export class NullToSimpleSapELementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        return [];
    }
}
